import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { SafePipe } from '../../_pipes/safe.pipe';
import { MiscService } from '../../_service/misc.service';
import {ConfirmationModalComponent} from '../../common/confirmation-modal/confirmation-modal.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
declare var $: any;
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage:number=25;usersList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;circles=[];circle='';
    search:string;currentUserId:any;circles_copy=[];status='';treatCategory=[];tcatergory='';
    booleanValue: any = false;cm_access='';userRoles=[];userRoles_copy=[];roles='';
    history_loading:boolean=true;history_loaded:boolean=false;updatedLodData=[];
    constructor(public miscapi:MiscService,private userapi:UserService,private sharedapi:SharedService,public leadapi:LeadsService,private dialog: MatDialog,private myRoute: Router) { }

    sortFunction(colName, boolean) {
        if (boolean == true){
            this.usersList.sort((a, b) => a[colName] < b[colName] ? 1 : a[colName] > b[colName] ? -1 : 0)
            this.booleanValue = !this.booleanValue
        }
        else{
            this.usersList.sort((a, b) => a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0)
            this.booleanValue = !this.booleanValue
        }
    }

    resetFilters()
    {
        this.search = ''; this.circle = ''; this.status = ''; this.tcatergory = ''; this.roles='';
        this.loadUsersList(0,25);
    }

    ngOnInit(): void
    {
        this.getcircle();
        this.getTreatmentCategory();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});

        this.myrole = localStorage.getItem('role');
        this.cm_access = localStorage.getItem('CMAccess');
        this.currentUserId = localStorage.getItem('loginuserId');

        if(this.myrole=='3' && this.cm_access!='1'){
            this.sharedapi.presentToast('Access Denied!');
            this.myRoute.navigate(['dashboard']);
        }
        this.getUserRoles();
    }
    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    setSearchValue(type){
        if (type == 'circle') {
        $("#circleSearch").val('');
        $("#circleSearch").focus();
        this.circles= this.circles_copy;
        }else if(type == 'roles') {
        $("#rolesSearch").val('');
        $("#rolesSearch").focus();
        this.userRoles= this.userRoles_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else if (type == 'roles') {
            this.userRoles = this.sharedapi.searchData(searchtText, this.userRoles_copy, "role_name");
        }
    }

    ngAfterViewInit() {
         this.loadUsersList(0,this.perpage);
    }

    async loadUsersList(pageIndex,perpage)
    {
    	this.usersList = [];
        this.paginator.pageIndex = pageIndex;
    	let qString = 'search='+this.search+'&circle='+this.circle+'&status='+this.status+'&tcatergory='+this.tcatergory+'&userRole='+this.roles;
        this.loading = true;this.loaded = false;
        this.userapi.getUserList(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
        	this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.usersList = data.data;
            }else{
                this.usersList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    getCircleName(circleData){
        var splittedStringArray = circleData.split(",");
        let circleNames='';
        splittedStringArray.forEach(element => {
            circleNames += '<span class="circleNamestyle">' + element + '</span>';
        });
        return circleNames;
    }
    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadUsersList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadUsersList(event.pageIndex,event.pageSize);
    }


    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    onStatusChange(event,id,index){
        let status;
        if(event.checked){
            status=1;
        }else{
            status=0;
        }
        let value = {
            'id':id,
            'status':status
        }
        this.userapi.updateUserStatus(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Status Update Successfully');
                this.usersList[index].status=data.data.status;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });

    }

    onStatusChangeMeetingRoom(event,id,index){
        let meeting_room_access_status;
        if(event.checked){
            meeting_room_access_status=1;
        }else{
            meeting_room_access_status=0;
        }
        let value = {
            'id':id,
            'meeting_room_access':meeting_room_access_status
        }
        this.userapi.updateUserMeetingRoomAccessStatus(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Meeting Room status Update Successfully');
                this.usersList[index].meeting_room_access=data.data.meeting_room_access;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });

    }

    leadAssignEnable(event,id,index){
        let lead_assign_enable;
        if(event.checked){
            lead_assign_enable=1;
        }else{
            lead_assign_enable=0;
        }
        let value = {
            'id':id,
            'lead_assign_enable':lead_assign_enable
        }
        this.userapi.updateUserLeadAssignStatus(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Lead Assignment Enable Update Successfully');
                this.usersList[index].lead_assign_enable=data.data.lead_assign_enable;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });

    }

    make_as_affiliate(event,id,index){
        let mark_as_affiliate;
        if(event.checked){
            mark_as_affiliate=1;
        }else{
            mark_as_affiliate=0;
        }
        let value = {
            'id':id,
            'mark_as_affiliate':mark_as_affiliate
        }
        this.userapi.updateUserMarkAffiliateStatus(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Update Successfully');
                this.usersList[index].mark_as_affiliate=data.data.mark_as_affiliate;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });
    }

    deleteUser(userId) {

        const dialogRef = this.dialog.open(ConfirmationModalComponent,{
          width: '350px',
          backdropClass: 'backdropBackground',
          data:{
            message: 'Are you sure want to delete?',
            buttonText: {
              ok: 'Confirm',
              cancel: 'No'
            }
          }
        });


        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
            let data={
                'id':userId
            }
            this.userapi.deleteUser(data)
            .subscribe((data:any) => {
                this.loading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('User Deleted Successfully');
                    this.loadUsersList(0,this.perpage);

                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
            }, error =>
            {
                this.sharedapi.checkError(error);
            });

          }
        });
    }

    /**
     * This functoion will delete one user session
     */
    deleteUserSession(userId) {

      const dialogRef = this.dialog.open(ConfirmationModalComponent,{
        width: '350px',
        backdropClass: 'backdropBackground',
        data:{
          message: 'Are you sure want to delete user session?',
          buttonText: {
            ok: 'Confirm',
            cancel: 'No'
          }
        }
      });


      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          let data={
              'id':userId
          }
          this.userapi.deleteUserSession(data)
          .subscribe((data:any) => {
              this.loading = false;
              if(data.status)
              {
                  this.sharedapi.presentToast('User Session Deleted Successfully');
                  this.loadUsersList(0,this.perpage);

              }
              else
              {
                  this.sharedapi.presentToast(data.msg);
              }
          }, error =>
          {
              this.sharedapi.checkError(error);
          });

        }
      });
  }

  /**
     * This functoion will delete all user session
     */
   deleteAllUserSession(userId='all') {

    const dialogRef = this.dialog.open(ConfirmationModalComponent,{
      width: '350px',
      backdropClass: 'backdropBackground',
      data:{
        message: 'Are you sure want to delete all user session?',
        buttonText: {
          ok: 'Confirm',
          cancel: 'No'
        }
      }
    });


    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let data={
            'id':userId
        }
        this.userapi.deleteUserSession(data)
        .subscribe((data:any) => {
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('All User Session Deleted Successfully');
                this.loadUsersList(0,this.perpage);

            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });

      }
    });
  }

  openUserHistoryPopup(userId)
    {
        this.history_loading = true;this.history_loaded = false;
        this.userapi.getUserHistory(userId).subscribe((data:any) => {
            this.history_loading = false;
            this.history_loaded = true;
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        $('#myHistoryModal').modal();
    }

    closeHistoryPopup()
    {
        $('#myHistoryModal').modal('hide');
    }
    async getUserRoles()
    {
        await this.leadapi.getUserRoles().subscribe((data:any) => {
            if(data.status)
            {
                this.userRoles = data.data;
                this.userRoles_copy = this.userRoles;
            }else{
                this.userRoles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    SaveDisplayNumber(event: any,user_id){
        let value = {
            'id':user_id,
            'display_number':event.target.value
        }
        if(value.display_number.length==10 || value.display_number.length==0 ){
            this.userapi.updateUserDisplayNumber(value).subscribe((data:any)=>{
            if(data.status)
            {
            this.sharedapi.presentToast('Update Display Number Successfully');
            }else{
            this.sharedapi.presentToast(data.msg);
            }
            }, error =>
            {
                this.sharedapi.checkError(error);
            });
        }else{
            this.sharedapi.presentToast('Please put 10 digit mobile number');
        }
    }

}

